import { createContext, useContext, useState, useEffect } from "react";
import { apiFetch } from "../hooks/apiFetch";
import { useUser } from "./User/UserContext";

const PaymentTokContext = createContext();

export function PaymentProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [paymentToken, setPaymentToken] = useState(null);
    const { isLogIn } = useUser();

    useEffect(() => {
        if (!isLogIn) {
            setPaymentToken(null);
            setLoading(false);
            return;
        }

        async function fetchPaymentTok() {
            try {
                const payToken = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/payment/token`);

                setPaymentToken(payToken);
            } catch (err) {
                setPaymentToken(null);
            }
            finally {
                setLoading(false);
            }
        }
        fetchPaymentTok();
        // }
    }, [isLogIn]);

    return (
        <PaymentTokContext.Provider
            value={{
                loading, paymentToken, setPaymentToken, setLoading
            }}>
            {children}
        </PaymentTokContext.Provider>
    );
}

export function usePaymentTok() {
    return useContext(PaymentTokContext);
}